import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../wayfinder'
/**
* @see \App\Http\Controllers\Company\Atlas\RtdfController::store
* @see app/Http/Controllers/Company/Atlas/RtdfController.php:24
* @route '/companies/{company}/atlas/rtdf'
*/
export const store = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

store.definition = {
    methods: ["post"],
    url: '/companies/{company}/atlas/rtdf',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Company\Atlas\RtdfController::store
* @see app/Http/Controllers/Company/Atlas/RtdfController.php:24
* @route '/companies/{company}/atlas/rtdf'
*/
store.url = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { company: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { company: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            company: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
    }

    return store.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Company\Atlas\RtdfController::store
* @see app/Http/Controllers/Company/Atlas/RtdfController.php:24
* @route '/companies/{company}/atlas/rtdf'
*/
store.post = (args: { company: string | { id: string } } | [company: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: store.url(args, options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Company\Atlas\RtdfController::destroy
* @see app/Http/Controllers/Company/Atlas/RtdfController.php:47
* @route '/companies/{company}/atlas/rtdf/{rtdfBranchMapping}'
*/
export const destroy = (args: { company: string | { id: string }, rtdfBranchMapping: string | number } | [company: string | { id: string }, rtdfBranchMapping: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

destroy.definition = {
    methods: ["delete"],
    url: '/companies/{company}/atlas/rtdf/{rtdfBranchMapping}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Company\Atlas\RtdfController::destroy
* @see app/Http/Controllers/Company/Atlas/RtdfController.php:47
* @route '/companies/{company}/atlas/rtdf/{rtdfBranchMapping}'
*/
destroy.url = (args: { company: string | { id: string }, rtdfBranchMapping: string | number } | [company: string | { id: string }, rtdfBranchMapping: string | number ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            company: args[0],
            rtdfBranchMapping: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        company: typeof args.company === 'object'
        ? args.company.id
        : args.company,
        rtdfBranchMapping: args.rtdfBranchMapping,
    }

    return destroy.definition.url
            .replace('{company}', parsedArgs.company.toString())
            .replace('{rtdfBranchMapping}', parsedArgs.rtdfBranchMapping.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Company\Atlas\RtdfController::destroy
* @see app/Http/Controllers/Company/Atlas/RtdfController.php:47
* @route '/companies/{company}/atlas/rtdf/{rtdfBranchMapping}'
*/
destroy.delete = (args: { company: string | { id: string }, rtdfBranchMapping: string | number } | [company: string | { id: string }, rtdfBranchMapping: string | number ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: destroy.url(args, options),
    method: 'delete',
})

const rtdf = {
    store: Object.assign(store, store),
    destroy: Object.assign(destroy, destroy),
}

export default rtdf